// import { defineRouter } from '#q-app/wrappers'
// import {
//   createRouter,
//   createMemoryHistory,
//   createWebHistory,
//   createWebHashHistory,
// } from 'vue-router'

import { createRouter, createWebHistory } from 'vue-router'

import routes from './routes.js'

import { route } from 'quasar/wrappers'
import { useAuth } from 'stores/auth-store'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

// export default defineRouter(function (/* { store, ssrContext } */) {
//   const createHistory = process.env.SERVER
//     ? createMemoryHistory
//     : process.env.VUE_ROUTER_MODE === 'history'
//       ? createWebHistory
//       : createWebHashHistory

//   const Router = createRouter({
//     scrollBehavior: () => ({ left: 0, top: 0 }),
//     routes,

//     // Leave this as is and make changes in quasar.conf.js instead!
//     // quasar.conf.js -> build -> vueRouterMode
//     // quasar.conf.js -> build -> publicPath
//     history: createHistory(process.env.VUE_ROUTER_BASE),
//   })

//   return Router
// })

export default route(function ({ store }) {
  const Router = createRouter({
    history: createWebHistory(process.env.VUE_ROUTER_BASE),
    routes,
  })

  Router.beforeEach(async (to, _from, next) => {
    // Use the shared Pinia instance from Quasar app
    const auth = useAuth(store)

    // If navigating to login page
    if (to.name === 'login') {
      // Only redirect to home if truly authenticated (has token AND valid session)
      // Don't redirect if we just got logged out due to invalid session
      if (auth.isAuthenticated && auth.me) {
        return next({ name: 'home' })
      }
      return next()
    }

    // For all other routes, keep URL at home but allow navigation internally
    if (to.path !== '/' && to.name !== 'login') {
      // Prevent URL from changing - stay at home route
      return next({ path: '/', replace: true })
    }

    // For protected routes, verify authentication
    if (auth.isAuthenticated && !auth.me) {
      try {
        await auth.fetchMe()
      } catch {
        // Session invalid - clear auth and redirect to login
        auth.token = null
        auth.me = null
        localStorage.removeItem('token')
        localStorage.removeItem('me')
        return next({ name: 'login', query: { redirect: to.fullPath } })
      }
    }

    if (to.meta.requiresAuth && !auth.isAuthenticated) {
      next({ name: 'login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  })

  return Router
})
